import React from 'react';
import '../../style/animations.css'

interface GlowBackgroundProps {
    children?: React.ReactNode;
}

const GlowBackground: React.FC<GlowBackgroundProps> = ({ children }) => {
    return (
        <div className="absolute left-0 min-h-screen text-white font-sans text-center pt-[20vh] overflow-hidden">
            <div className="glowing-layer" />
            {children}
        </div>
    );
};

export default GlowBackground;



